// styles
import { customStyled } from "styles/theme"
import { styled, Typography } from "@mui/material"

export const STitle = customStyled(Typography)(
  ({
    theme: {
      breakpoints,
      typography: { mobileH1 },
      spacing,
    },
  }) => ({
    fontSize: "32px",
    marginBottom: spacing(4),
    [breakpoints.down("sm")]: {
      ...mobileH1,
      marginBottom: spacing(4),
    },
  })
)

export const SText = customStyled(Typography)(
  ({
    theme: {
      palette,
      breakpoints,
      typography: { mobileH3 },
      spacing,
    },
  }) => ({
    color: palette.grey["600"],
    marginBottom: spacing(7),
    lineHeight: 1.2,
    [breakpoints.down("sm")]: {
      ...mobileH3,
    },

    "& span": {
      color: palette.secondary.main,
    },
  })
)

export const SRightText = customStyled(Typography)(
  ({
    theme: {
      breakpoints,
      palette,
      typography: { h5 },
    },
  }) => ({
    lineHeight: "100%",
    fontWeight: 400,
    [breakpoints.down("sm")]: {
      ...h5,
    },

    "& span": {
      color: palette.secondary.main,
    },
  })
)

export const SEfnOrDocumentText = customStyled(Typography)(
  ({
    theme: {
      spacing,
      typography: { mobileH3 },
      breakpoints,
      palette,
    },
  }) => ({
    marginTop: "auto",
    marginBottom: spacing(4),
    paddingLeft: spacing(8),
    paddingRight: spacing(8),
    [breakpoints.down("sm")]: {
      ...mobileH3,
    },
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    gap: spacing(8),
    "&::before, &::after": {
      content: '""',
      flex: 1,
      borderBottom: `1px solid ${palette.grey[500]}`,
    },
  })
)

export const SPrivateCourseColoredTitle = styled("span")(({ theme }) => ({
  color: theme.palette.secondary.main,
}))
